import FeedbackButtonStatus from '../../store/viewSchema/FeedbackButtonStatus';
import isEmailDonationSupported from '../../utils/featureChecks/isEmailDonationSupported';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';

export default function getFeedbackButtonStatus(txpStatus: TxpStatus): FeedbackButtonStatus {
    if (txpStatus && txpStatus.isEmailDonationRequested && isEmailDonationSupported()) {
        return FeedbackButtonStatus.teeTriggeredReportIssue;
    }

    return FeedbackButtonStatus.defaultState;
}
